import { createAsyncThunk } from '@reduxjs/toolkit';

import { IGroupedTopicsWithSubTopicsData, ISubTopic } from '.';
import { ApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';

const SubTopicApiDataProvider = new APIDataProvider<ISubTopic>();
const SubtopicGroupByTopicApiDataProider = new APIDataProvider<IGroupedTopicsWithSubTopicsData>();

export const getSubTopicById = createAsyncThunk(
  'subtopic/id',
  async (id: string) => {
    const response = await SubTopicApiDataProvider.getById(
      `${ApiPaths.subTopic}/${id}`
    );
    return response.data;
  }
);

export const getGroupedSubTopics = createAsyncThunk(
  'subTopic/groupedSubTopics',
  async (data: { subTopicId: string }) => {
    const response = await SubtopicGroupByTopicApiDataProider.create(
      `${ApiPaths.subTopic}/groupedSubTopics`,
      data
    );

    return response.data;
  }
);
